import React from 'react';
import { Box, Typography, Paper, Grid, Divider } from '@mui/material';

const StatCard = ({ title, value, color }) => (
  <Paper elevation={2} sx={{ p: 2, textAlign: 'center', height: '100%' }}>
    <Typography variant="subtitle2" color="text.secondary">{title}</Typography>
    <Typography variant="h5" fontWeight="bold" color={color}>{value}</Typography>
  </Paper>
);

const PerformansPuanHesabi = ({ chartData }) => {
  
  if (!chartData || chartData.length === 0) {
    return null;
  }

  
  const sonDonem = chartData[chartData.length - 1];

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" gutterBottom>
        Son Dönem Performans Değerlendirmesi (Dönem {sonDonem.DONEM_NO})
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6} sm={3}>
          <StatCard title="Kötü" value={sonDonem.KOTU_PERFORMANS} color="error.main" />
        </Grid>
        <Grid item xs={6} sm={3}>
          <StatCard title="Orta" value={sonDonem.ORTALAMA_PERFORMANS} color="warning.main" />
        </Grid>
        <Grid item xs={6} sm={3}>
          <StatCard title="İyi" value={sonDonem.IYI_PERFORMANS} color="success.light" />
        </Grid>
        <Grid item xs={6} sm={3}>
          <StatCard title="Mükemmel" value={sonDonem.MUKEMMEL_PERFORMANS} color="primary.main" />
        </Grid>
      </Grid>
      <Divider sx={{ my: 3 }} />
    </Box>
  );
};

export default PerformansPuanHesabi;